import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';

import { TextField } from 'libs/forms/views/fieldTypes/text';
import FormActionButton from 'libs/forms/views/formActionButton';
import { FormWrapper, Label, FormField } from 'libs/forms/styles';

import { FormPage } from 'legacyComponents/pages/formPage';
import { Center, Message } from 'legacyComponents/styled/lib';

import { Spinner, Paragraph } from 'components';

import Header from 'apps/components/header/header';

import { GatewayManager } from 'apps/gateway/appManager';

@observer
export class GatewayPage extends React.Component {
  constructor(props) {
    super(props);
    this.gatewayManager = new GatewayManager(this, props);
    this.intentInputRef = React.createRef();
    this.userTypeInputRef = React.createRef();
  }

  render() {
    if (this.gatewayManager.loading) {
      return (
        // TODO: replace by Loading component
        <>
          <Spinner margin='80px auto 10px' />
          <Center>
            <Paragraph>Signing in...</Paragraph>
          </Center>
        </>
      );
    }

    const { profile } = this.gatewayManager;
    const { gatewayForm } = profile;
    const usernameField = gatewayForm.fieldStores.get('username');
    const emailField = gatewayForm.fieldStores.get('email');
    const fullNameField = gatewayForm.fieldStores.get('fullName');

    return (
      <main>
        <Header noNav />
        <FormPage
          title='Please review your profile information'
          formTitle={"Anything you'd like to change?"}
          noBackButton
        >
          <FormWrapper posting={gatewayForm.posting}>
            <FormField>
              <Label>
                <Trans>{usernameField.conf.label}</Trans>
              </Label>
              <TextField fieldStore={usernameField} />
            </FormField>
            {emailField && (
              <FormField>
                <Label>
                  <Trans>{emailField.conf.label}</Trans>
                </Label>
                <TextField fieldStore={emailField} />
              </FormField>
            )}
            <FormField>
              <Label>
                <Trans>{fullNameField.conf.label}</Trans>
              </Label>
              <TextField fieldStore={fullNameField} />
            </FormField>
            <Message>
              <span>
                By clicking “Complete Sign Up”, you accept our{' '}
                <a href='/terms'>Terms & Conditions</a> and{' '}
                <a href='/privacy'>Privacy Policy</a>.
              </span>
            </Message>
            <Center>
              <FormActionButton
                formStore={gatewayForm}
                buttonText='Complete Sign Up'
                buttonTextPosting='Creating Profile on Wikifactory...'
                marginTop='0px'
                marginBottom='20px'
                buttonHandler={() => {
                  gatewayForm.prepare();
                  this.gatewayManager.Submit();
                }}
              />
            </Center>
          </FormWrapper>
        </FormPage>
      </main>
    );
  }
}

GatewayPage.propTypes = {
  params: PropTypes.object,
};
